import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { Views, DefaultView } from '../../types/BlockWithViews';
import { TeaserInformationDefaultView } from './views/TeaserInformationDefaultView';
import { BlockType } from '../../types/api/ElementType';

type TeaserInformationProps = Views<DefaultView<TeaserInformationDefaultView>>;

function TeaserInformation({ views }: TeaserInformationProps) {
  return <TeaserInformationDefaultView {...views.default} />;
}

export const TeaserInformationBlock = asFetchableBlock(TeaserInformation, BlockType.teaserinformation);
export type TeaserInformationBlock = ComponentProps<typeof TeaserInformationBlock>;
